import { UploadCloud, FileUp, Image as ImageIcon, Music, Video } from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatBytes } from "@/lib/format";
import { FileRow } from "./FileRow";

export const UPLOAD_TABS = [
  { key: "file", label: "File", icon: FileUp, accept: undefined },
  { key: "image", label: "Image", icon: ImageIcon, accept: "image/*" },
  { key: "audio", label: "Audio", icon: Music, accept: "audio/*" },
  { key: "video", label: "Video", icon: Video, accept: "video/*" },
];

export function UploadTabs({ value, onChange }) {
  return (
    <div className="mb-3 flex justify-center gap-1 rounded-full bg-slate-100 p-1 sm:mx-auto sm:w-fit" role="tablist" aria-label="Upload type">
      {UPLOAD_TABS.map((t) => (
        <button key={t.key} role="tab" aria-selected={value === t.key} onClick={() => onChange(t.key)} className={`flex flex-1 items-center justify-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors sm:flex-none sm:px-4 ${value === t.key ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-800"}`} data-testid={`upload-tab-${t.key}`}>
          <t.icon className="h-3.5 w-3.5" />{t.label}
        </button>
      ))}
    </div>
  );
}

export function EmptyDropzone({ settings, maxSize, onChoose }) {
  return (
    <>
      <div className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-white text-indigo-600 shadow-sm"><UploadCloud className="h-7 w-7" /></div>
      <p className="mt-5 text-lg font-semibold text-slate-900">{settings.upload_instructions}</p>
      <p className="mt-1 text-sm text-slate-500">or</p>
      <Button type="button" onClick={(e) => { e.stopPropagation(); onChoose(); }} className="mt-3 h-11 rounded-full bg-indigo-600 px-6 text-sm font-semibold hover:bg-indigo-700 sm:h-10" data-testid="choose-files-btn">{settings.cta_choose_files}</Button>
      <p className="mt-5 text-xs text-slate-400" data-testid="max-size-hint">Files up to {formatBytes(maxSize, 0)}</p>
    </>
  );
}

export function UploadList({ items, busy, allowMore, onRemove, onCancel, onRetry, onAddMore }) {
  return (
    <div className="space-y-2 text-left" onClick={(e) => e.stopPropagation()}>
      {items.map((item) => (
        <FileRow key={item.id} item={item} onRemove={() => onRemove(item.id)} onCancel={() => onCancel(item.id)} onRetry={() => onRetry(item)} />
      ))}
      {allowMore && !busy && (
        <button type="button" onClick={onAddMore} className="w-full rounded-xl border border-dashed border-slate-300 py-2.5 text-xs font-medium text-slate-500 hover:border-indigo-400 hover:text-indigo-600" data-testid="add-more-files-btn">+ Add more files</button>
      )}
    </div>
  );
}
